import React from 'react'
import * as Sentry from '@sentry/react'
import {
  captureConsoleIntegration,
  consoleLoggingIntegration,
} from '@sentry/react'
import { createRoot } from 'react-dom/client'
import { App } from './app'

declare global {
  interface Window {
    CONFIG?: {
      SENTRY_DSN?: string
      [key: string]: unknown
    }
  }
}

const sentryDsn = window?.CONFIG?.SENTRY_DSN
const commitHash = import.meta.env.VITE_CURRENT_COMMIT_HASH
const SENTRY_LOG_LEVELS = (window?.CONFIG?.SENTRY_LOG_LEVELS || []) as string[]

const hostname =
  typeof window !== 'undefined' && window.location?.hostname
    ? window.location.hostname
    : 'unknown-host'

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: hostname,
    enableLogs: true,
    integrations: [captureConsoleIntegration({ levels: SENTRY_LOG_LEVELS })],
    release:
      typeof commitHash === 'string' && commitHash.length > 0
        ? commitHash
        : undefined,
  })
}

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(<App />)
} else {
  console.error('No root element found')
}
